import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const WorksheetDivider = ({ label, children }) => (
  <Grid.Row className="WorksheetDivider" columns={2}>
    <Grid.Column textAlign="left" width={11}>
      <span className="WorksheetDivider__label">{label}</span>
    </Grid.Column>
    <Grid.Column textAlign="left" width={5}>
      {children}
    </Grid.Column>
  </Grid.Row>
)

WorksheetDivider.propTypes = {
  label: PropTypes.string
}

export default WorksheetDivider
